import React from "react";

export const LogoMark = ({ className = "h-9 w-9" }) => (
  <svg viewBox="0 0 64 64" className={className} aria-hidden="true">
    <rect width="64" height="64" rx="14" fill="#0A192F" />
    <path d="M18 46V18l28 28V18" stroke="#F9F8F3" strokeWidth="5" fill="none" strokeLinecap="square" />
    <circle cx="51" cy="15" r="4.5" fill="#C49A45" />
  </svg>
);

const Logo = ({ light = false, caption = true }) => (
  <span className="inline-flex items-center gap-3">
    <LogoMark className="h-9 w-9 shrink-0" />
    <span className="flex flex-col leading-none">
      <span className={`font-serif text-[26px] font-medium tracking-tight ${light ? "text-ivory" : "text-ink"}`}>
        Naditra<span className="text-cyan">.</span>
      </span>
      {caption && (
        <span className={`mt-1 text-[11px] font-bold uppercase tracking-[0.18em] ${light ? "text-ivory/70" : "text-smoke"}`}>
          Travel Price Concierge
        </span>
      )}
    </span>
  </span>
);

export default Logo;
